import { render, staticRenderFns } from "./NoticeBanner.vue?vue&type=template&id=42793276&scoped=true&"
import script from "./NoticeBanner.vue?vue&type=script&lang=ts&"
export * from "./NoticeBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42793276",
  null
  
)

export default component.exports